<ngb-toast
    class="toast-overwrite"
    *ngFor="let toast of toasts"
    [class]="toast.cssClassName"
    [animation]="true"
    [delay]="toast.autoHideDelay || 4000"
    [autohide]="autoHide"
    (mouseenter)="stopAutoHide()"
    (mouseleave)="startAutoHide()"
    (hidden)="closeNotification(toast.id)"
>
    <div
        *ngIf="toast.titleLocalizationKey"
        class="notification-header"
        style="margin-bottom: 8px"
        [ngClass]="toast.type === notificationType.ERROR? 'red': 'white'"
    >
        <span *ngIf="toast.type === notificationType.ERROR" class="ham-icon icon">
            <i class="exclamation-fill-icon"></i>
        </span>
        <span *ngIf="toast.type === notificationType.SUCCESS" class="ham-icon icon">
            <i class="check-circle"></i>
        </span>
        <h5 class="title d-inline-block" [ngClass]="toast.type === notificationType.ERROR? 'red': 'white'">
            {{ toast.titleLocalizationKey | i18next }}
        </h5>
        <span class="ham-icon icon" (click)="closeNotification(toast.id)">
            <i class="x-icon"></i>
        </span>
    </div>
    <div *ngIf="toast.titleLocalizationKey" class="notification-content-container">
        <span class="description" [ngClass]="toast.type === notificationType.ERROR? 'red': 'white'"
            >{{toast.descriptionLocalizationKey | i18next }}</span
        >
        <!-- REV-21374 — die optionale Handlung, z. B. „Rueckgaengig". Ohne `actionLabelKey` ist
             hier nichts, und der Toast sieht aus wie bisher.

             ⚠️ Ein `button` mit `class` — aber er SIEHT aus wie ein Verweis: fett und
             unterstrichen. Vorher trug er die Knopf-Gestaltung des Browsers und sass als graues
             Kaestchen im dunklen Toast. Ein `button` bleibt es trotzdem, weil es eine Handlung
             ist und keine Adresse: Tastatur, Vorlesesoftware und Enter hängen daran. -->
        <button
            *ngIf="toast.actionLabelKey"
            type="button"
            class="notification-action"
            data-testid="notification-action"
            [ngClass]="toast.type === notificationType.ERROR ? 'red' : 'white'"
            (click)="triggerAction(toast)"
        >
            {{ toast.actionLabelKey | i18next }}
        </button>
    </div>

    <!-- Die Frist, sichtbar: der Balken läuft genau so lange, wie die Handlung oben gilt. -->
    <div
        class="notification-progress"
        data-testid="notification-progress"
        *ngIf="toast.actionProgress"
        aria-hidden="true"
    >
        <span class="notification-progress__bar" [style.animation-duration.ms]="toast.autoHideDelay || 4000"></span>
    </div>
    <div
        *ngIf="!toast.titleLocalizationKey"
        class="notification-header"
        [ngClass]="toast.type === notificationType.ERROR? 'red': 'white'"
    >
        <span *ngIf="toast.type === notificationType.ERROR" class="ham-icon icon">
            <i class="exclamation-fill-icon"></i>
        </span>
        <span *ngIf="toast.type === notificationType.SUCCESS" class="ham-icon icon">
            <i class="check-circle"></i>
        </span>
        <span class="description" [ngClass]="toast.type === notificationType.ERROR? 'red': 'white'"
            >{{toast.descriptionLocalizationKey | i18next }}</span
        >
        <span class="ham-icon icon" (click)="closeNotification(toast.id)">
            <i class="x-icon"></i>
        </span>
    </div>
</ngb-toast>
